import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import UserNav from "../Common/UserNav";
import PricingTwo from "../Pricing/PricingTwo";
import CheckoutForm from "../Checkout/CheckoutForm";
import Return from "../Checkout/Return";
import { createManageAccountSessionApi } from "@/services/userApi";
const PlansBilling = ({ page }) => {

  const router = useRouter();

  const [manageAccountUrl, setManageAccountUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
      createManageAccountSessionApi()
        .then(setManageAccountUrl)
        .catch(console.error);

      setIsLoading(false);
  }, [page]); 

  return (
    <>
      <div className="rbt-main-content mr--0 mb--0">
        <div className="rbt-daynamic-page-content center-width">
          <div className="rbt-dashboard-content">
            <UserNav title="Plans & Billing" />
            <div className="content-page pb--50">
              {isLoading ? (
                <div className="loading-spinner"></div>
              ) : (
                <>
                  {page === "checkout" ? (
                <CheckoutForm />
              ) : 
              page === "return" ? (
                <Return />
              ) : (
                <PricingTwo
                  parentClass="col-xl-4 col-lg-6 col-md-6 col-12"
                  childClass="tab-content bg-transparent bg-light"
                  start={0}
                  end={2}
                  isHeading={false}
                  gap={false}
                  manageAccountUrl={manageAccountUrl}
                  isLoading={isLoading}
                />  
              )}
                </>
              )}
              {/* The empty div below can be removed if not needed */}
              {/* <div className="row jureeltd-section-gap row--20"></div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PlansBilling;
